export const EXACT_PUBLIC_COORDINATES_REQUIRED_MESSAGE =
  "We couldn't find map coordinates for that public address. Please enter the map pin latitude and longitude, or choose general area only.";

const parseOptionalCoordinate = (value, min, max) => {
  const text = String(value ?? "").trim();
  if (!text) return { value: null, invalid: false };

  const numberValue = Number(text);
  return {
    value: numberValue,
    invalid: !Number.isFinite(numberValue) || numberValue < min || numberValue > max,
  };
};

export const parsePublicCoordinateInputs = (publicLat = "", publicLng = "") => {
  const lat = parseOptionalCoordinate(publicLat, -90, 90);
  const lng = parseOptionalCoordinate(publicLng, -180, 180);

  return {
    parsedPublicLat: lat.value,
    parsedPublicLng: lng.value,
    invalid: lat.invalid || lng.invalid,
  };
};

export const hasPublicCoordinatePair = (lat, lng) =>
  Number.isFinite(lat) && Number.isFinite(lng);

export const getMissingExactPublicCoordinatesMessage = (
  usesExactPublicLocation,
  lat,
  lng
) =>
  usesExactPublicLocation && !hasPublicCoordinatePair(lat, lng)
    ? EXACT_PUBLIC_COORDINATES_REQUIRED_MESSAGE
    : "";
